import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip'

export default function ToolTip({ content }) {
    return (
        <>
            <Tooltip id="wps-tooltip" />
            <span
                className="tooltip-container"
                data-tooltip-id="wps-tooltip"
                data-tooltip-content={content}
                data-tooltip-place="top-end"
            >
                <FaInfoCircle color="#2196F3" size="11px" />
            </span>
        </>
    );
}